<template>
  <div>
    <component :is="currentScenario"></component>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { mapActions } from 'vuex'

  import Loader from './../utils/Loader'

  import {
    EVENT_SET_SCENARIO,
    EVENT_SET_PROGRESS,
    EVENT_NEXT_STEP,
    EVENT_PREV_STEP,
    EVENT_SET_STEP
  } from '@/constants';

  export default {
    name: "scenario",
    components: {
      //NA Scenarios
      'activity_outside_business_hours': () => ({
        component: import('./na_activity_outside_business_hours/Screen'),
        loading: Loader,
      }),
      'alerts': () => ({
        component: import('./na_alerts/Screen'),
        loading: Loader,
      }),
      'behavior_anomaly_discovery': () => ({
        component: import('./na_behavior_anomaly_discovery/Screen'),
        loading: Loader,
      }),
      'compliance_reports': () => ({
        component: import('./na_compliance_reports/Screen'),
        loading: Loader,
      }),
      'data_discovery_and_classification': () => ({
        component: import('./na_data_discovery_and_classification/Screen'),
        loading: Loader,
      }),
      'folder_and_file_prm': () => ({
        component: import('./na_folder_and_file_prm/Screen'),
        loading: Loader,
      }),
      'overview': () => ({
        component: import('./na_overview/Screen'),
        loading: Loader,
      }),
      'risk_assessment': () => ({
        component: import('./na_risk_assessment/Screen'),
        loading: Loader,
      }),
      'search': () => ({
        component: import('./na_search/Screen'),
        loading: Loader,
      }),
      'user_account_changes': () => ({
        component: import('./na_user_account_changes/Screen'),
        loading: Loader,
      }),
      'welcome': () => ({
        component: import('./na_welcome/Screen'),
        loading: Loader,
      }),
      'windows_server_configuration': () => ({
        component: import('./na_windows_server_configuration/Screen'),
        loading: Loader,
      }),
      //NDC Scenarios
      'ndc_welcome': () => ({
        component: import('./ndc_welcome/Screen'),
        loading: Loader,
      }),
      'risk_mitigation': () => ({
        component: import('./ndc_risk_mitigation/Screen'),
        loading: Loader,
      }),
      'clean_up_enterprise_content': () => ({
        component: import('./ndc_clean_up_enterprise_content/Screen'),
        loading: Loader,
      }),
      'records_management': () => ({
        component: import('./ndc_records_management/Screen'),
        loading: Loader,
      }),
      'ediscovery': () => ({
        component: import('./ndc_ediscovery/Screen'),
        loading: Loader,
      }),
      'dsar': () => ({
        component: import('./ndc_dsar/Screen'),
        loading: Loader,
      }),
      'sta_welcome': () => ({
        component: import('./sta_welcome/Screen'),
        loading: Loader,
      }),
      'identify_data_security_risks': () => ({
        component: import('./sta_identify_data_security_risks/Screen'),
        loading: Loader,
      }),
      'streamline_data_access_reviews': () => ({
        component: import('./sta_streamline_data_access_reviews/Screen'),
        loading: Loader,
      }),
      'satisfy_data_subject_access_requests': () => ({
        component: import('./sta_satisfy_data_subject_access_requests/Screen'),
        loading: Loader,
      }),
    },
    data() {
      return {}
    },
    computed: {
      ...mapState('guide', ['currentScenario', 'currentStep']),
      totalSteps() {
        return this.$store.getters['guide/totalSteps'];
      },
    },
    methods: {
      ...mapActions('guide', ['setScenario', 'goToStep']),
      nextStep() {
        this.$store.dispatch('guide/nextStep');
        this.$root.$emit(EVENT_SET_PROGRESS, (this.currentStep + 1) / this.totalsteps * 100);
      },
      prevStep() {
        this.$store.dispatch('guide/prevStep');
        this.$root.$emit(EVENT_SET_PROGRESS, (this.currentStep + 1) / this.totalsteps * 100);
      },
    },
    mounted() {
      this.$root.$on(EVENT_SET_SCENARIO, this.setScenario);
      this.$root.$on(EVENT_NEXT_STEP, this.nextStep);
      this.$root.$on(EVENT_PREV_STEP, this.prevStep);
      this.$root.$on(EVENT_SET_STEP, this.goToStep);
    },
    beforeDestroy() {
      this.$root.$off(EVENT_SET_SCENARIO);
      this.$root.$off(EVENT_NEXT_STEP);
      this.$root.$off(EVENT_PREV_STEP);
      this.$root.$off(EVENT_SET_STEP);
    }
  }
</script>

<style scoped>

</style>
